import {isFeatureEnabled} from '@github-ui/feature-flags'
import {TransactionalMessageBanner} from '@github-ui/in-product-targeting'
import type {HeaderPageData} from '../../page-data/payloads/header'
import {ReviewRequestBanner} from './ReviewRequestBanner'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import type {PullRequestAppPayload} from '../../page-data/payloads/pull-request-app'
import {useLocation} from '@github-ui/react-router'
import {useCallback} from 'react'

export function PullRequestsTopBanners({bannersData, urls}: Pick<HeaderPageData, 'bannersData' | 'urls'>) {
  const location = useLocation()
  const isCurrentLocation = useCallback((url: string) => location.pathname === url, [location])
  const isConversationRoute = isCurrentLocation(urls.conversation)

  const {transactionalMessageBanner} = useAppPayload<PullRequestAppPayload>()
  const showTransactionalMessageBanner =
    isFeatureEnabled('ipm_global_transactional_message_prs') && transactionalMessageBanner

  const showReviewRequestBanner = isConversationRoute && bannersData.banners.reviewRequestBanner.render

  const hasBanners = showTransactionalMessageBanner || showReviewRequestBanner

  if (!hasBanners) {
    return null
  }

  return (
    <div className={'d-flex flex-column gap-2 pr-mb-3'}>
      {showTransactionalMessageBanner ? <TransactionalMessageBanner banner={transactionalMessageBanner} /> : null}
      {showReviewRequestBanner && (
        <ReviewRequestBanner reviewRequest={bannersData.banners.reviewRequestBanner} urls={urls} />
      )}
    </div>
  )
}
